import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMessagesByStatus } from "../../../redux/slices/messagesSlice";
import { Table } from "react-bootstrap";

const SentMessages = () => {
  const dispatch = useDispatch();
  const { sent, isLoading, error } = useSelector((state) => state.messages);

  useEffect(() => {
    dispatch(fetchMessagesByStatus());
  }, [dispatch]);

  if (isLoading) return <p>Loading sent messages...</p>;
  if (error) return <p className="text-danger">Error: {error}</p>;

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th>To</th>
          <th>Content</th>
          <th>Sent At</th>
        </tr>
      </thead>
      <tbody>
        {sent.map((message, index) => (
          <tr key={message.id}>
            <td>{index + 1}</td>
            <td>{message.recipient.name || "desconhecido"}</td>
            <td>{message.content}</td>
            <td>{new Date(message.sent_at).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default SentMessages;